import React from 'react';
import OCProgram, {OCProgramProps} from './OCProgram';

interface ShortCodeProps {
  identifier: string;
  attributes: OCProgramProps | undefined;
}

function ShortCode({identifier, attributes}:ShortCodeProps) {
  const missing = (shortcode: string) => {
    return <div>Missing parameters to shortcode &apos;{shortcode}&apos;</div>;
  };

  switch (identifier) {
  case 'OC': {
    if (attributes === undefined) {
      return missing(identifier);
    }
    return <OCProgram program={attributes.program} />;
  }
  default: {
    return <div>Unknown shortcode &apos;{identifier}&apos;</div>;
  }
  }
}

export default ShortCode;
